<script>
    import LyInputText from './LyInputText.svelte';

    let {
        name = null,
        placeholder = null,
        id = null,
        label = null,
        required = false,
        value = $bindable(''),
        thisRef = $bindable(null),
        ...restProps
    } = $props();
</script>

<LyInputText {...restProps} bind:value bind:thisRef type="date" {id} {name} {label} {placeholder} {required} />
